import Reviews from './Reviews.container';

export default Reviews;
